import { postAjax } from './trade/index.js';

// 获取验证码
export const getPhoneCodeForTjSession = (data = {}, params = {}) => {
  return postAjax('account/getPhoneCodeForTjSession', data, params);
};

// 提交验证码
export const checkPhoneVerifyCodeForTj = (data = {}, params = {}) => {
  return postAjax('account/checkPhoneVerifyCodeForTj', data, params);
};
